import { render } from "./ImageWithDefault.vue?vue&type=template&id=05e5c6de&scoped=true"
import script from "./ImageWithDefault.vue?vue&type=script&lang=js"
export * from "./ImageWithDefault.vue?vue&type=script&lang=js"

import "./ImageWithDefault.vue?vue&type=style&index=0&id=05e5c6de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e5c6de"]])

export default __exports__